import styled from "styled-components";
import { cssBody200Bold } from "../../typography/styles";
export const Label = styled.div `
  ${cssBody200Bold};
  color: ${(p) => p.theme.systemColors.grey600};
`;
